import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PagingService} from '../service/paging.service';

@Component({
  selector: 'ui-pagination',
  template: `<div class="m-3">
  <nav aria-label="Page navigation example">
    <ul class="pagination justify-content-center">
      <ng-container>

        <li class="page-item " [ngClass]="{'disabled':pageNum === 1}" (click)="prev()" [attr.disabled]="pageNum === 1">
          <a class="page-link" tabindex="-1">Previous </a>
        </li>

        <li class="page-item" (click)="onPageChange(page)" *ngFor="let page of pages; index as i; first as isFirst; last as isLast;">
          <a class="page-link" [ngClass]="{'active disabled':pageNum===page}">{{page}}</a>
        </li>

        <li class="page-item" *ngIf=" pageCount > displayNumbers && lastPage < pageCount" [ngClass]="{'disabled':pageNum===pages.length}" (click)="shiftBoundary()">
          <a class="page-link">...</a>
        </li>

        <li class="page-item" *ngIf="pageCount > displayNumbers && lastPage < pageCount" [ngClass]="{'disabled':pageNum===pageCount}" (click)="onPageChange(pageCount)">
          <a class="page-link"> {{pageCount}}</a>
        </li>

        <li class="page-item" [ngClass]="{'disabled':pageNum === pageCount}" [attr.disabled]="(pageNum === pageCount)?'disabled':''" (click)="next()">
          <a class="page-link"> Next</a>
        </li>
      </ng-container>
    </ul>
  </nav>
</div>

`,
  styles: [`.page-link:not([href]):not([tabindex]){position:relative;display:block;padding:.5rem .75rem;margin-left:-1px;line-height:1.25;color:#337ab7;background-color:#fff;border:1px solid #dee2e6}.page-link.active:not([href]):not([tabindex]){position:relative;display:block;padding:.5rem .75rem;margin-left:-1px;line-height:1.25;color:#fff;background-color:#337ab7;border:1px solid #337ab7}.disabled{pointer-events:none}`]
})
export class PaginationComponent implements OnInit {
  @Input() totalCount: number;
  @Input() size = 10;
  @Output() pageChange = new EventEmitter();

  pageCount: number;
  pages: any[];
  pageNum: number = 1;
  totalPages: any[];
  displayNumbers: number = 5;
  lastPage: number = 5;

  constructor(private _pgs: PagingService) {
  }

  ngOnInit() {
    this._pgs.size = this.size;
    this._pgs.totalCount = this.totalCount;
    this.pageCount = this._pgs.getListOfPage(this.totalCount);
    this.totalPages = Array(this.pageCount).fill(0).map((e, i) => i + 1);
    this.pages = this.totalPages.slice(0, 5);
    this.lastPage = this.pages[this.displayNumbers - 1];
  }

  onPageChange(e) {
    console.log(e);
    this.pageNum = e;
    this.pageChange.emit({
      pageNum: e
    });
  }

  shiftBoundary(isReverse = false) {
    let startIndex = (isReverse) ? this.pageNum - this.displayNumbers : this.pageNum -1;
    let lastIndex = (isReverse) ? this.pageNum : this.pageNum + this.displayNumbers-1;
    this.pages = this.totalPages.slice(startIndex, lastIndex);
    this.lastPage = lastIndex;
  }

  next() {
    this.pageNum++;
    if (this.pageNum > this.lastPage) this.shiftBoundary();
  }

  prev() {
    this.pageNum--;
    if ((this.pageNum) % this.displayNumbers === 0) {
      this.shiftBoundary(true);
    }
  }
}
